
    import { Vue, Component } from 'vue-property-decorator'
    @Component({
        name: 'read'
    })
    export default class read extends Vue {
    dataForm={content:''}
    questionnaire= {}
    id = ''
    dialogImageUrl = ''
    fullscreenLoading = false
    dialogVisible = false
    fileList = []
    rules={
        content: [{required: true, trigger: 'blur', message: '请填写内容'}]
    }
     mounted(){

      }
     httpRequest(data){
         let _that=this;
         let rd = new FileReader(); // 创建文件读取对象
         let file = data.file;
         let formData = new FormData();
         formData.append('file', file);
         this.$request({
             method: 'post',
             url: '/bjba/fileupload/upload',
             data:formData,
             headers: {
                 'Content-Type': 'multipart/form-data',
             }
         }).then(res => {
             console.log(res.data)
             this.fileList.push({url:res.data.url})
         })
     }
     handlePictureCardPreview(file) {
         this.dialogVisible = true
         this.dialogImageUrl = file.url
     }
     handleRemove(file, fileList) {
         this.fileList.splice(this.fileList.findIndex(e => e.uid === file.uid), 1)
         if (file.url) {
             this.$request({
                 method: 'post',
                 url: '/bjba/fileupload/delete',
                 params:{url:file.url}
             }).then(res => {
                 console.log(res.data)
             })
         }
     }
     dataFormSubmit() {
         this.$refs['dataForm'].validate((valid) => {
             if (valid) {
                 this.fullscreenLoading = true
                 this.$http({
                     url: `/bjba/feedback/save`,
                     method: 'post',
                     data: {data:this.dataForm,urls:this.fileList.map(e=>e.url)}
                 }).then(({data}) => {
                     this.fullscreenLoading = false
                     if (data && data.code === 200) {
                         this.$message({
                             message: '提交成功',
                             type: 'success',
                             duration: 1500
                         })
                         this.dataForm.content = ''
                         this.fileList = []
                     } else if(data && data.code === 500) {
                         this.$message({
                             message: data.message,
                             type: 'error',
                             duration: 1500
                         })
                     }
                 })


             }
         })
    }
    toPageFeedbackList(url:string) {
        this.$router.push({
            path:url
        });
    }
    }
